'use client';

export { RainHistoryScreen } from './RainHistoryScreen';
